module.exports = __webpack_public_path__ + "img/Remittances-logo.685cb197.svg";